import React, { Component } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import Icon from '../../../../icons/Icon';
import { RootState } from '../../../../redux/store';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import { changeChart } from '../../../../redux/actions/ChartActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { LegendOptions } from 'chart.js';
import { Align } from 'chart.js/dist/types';

class LegendOptionPanel extends Component<Props, State> {
  private overlayPanelRef: OverlayPanel | null = null;
  public state = new State();

  render() {
    const {
      chart: { chart },
    } = this.props;
    const legend: LegendOptions<any> | undefined = chart.visualOptions?.plugins?.legend as any;
    if (!legend) return null;
    return (
      <button
        className={
          'w-8 h-8 rounded focus:border-f-purple focus:shadow-sm focus:shadow-[#728EFF]/25  hover:border-f-purple border-[1px] border-f-black-5  cursor-pointer bg-white shadow-sm shadow-black/5 flex items-center justify-center'
        }
      >
        <div onClick={this.openOverlayPanel}>
          <Icon icon={'legend'} size={24} className={'text-primary p-1'} />
        </div>
        <OverlayPanel ref={(el) => (this.overlayPanelRef = el)}>
          <div className={'flex flex-col w-[346px] items-start justify-start border-[1px] border-f-black-5'}>
            <header className={'flex items-center text-[12px] text-f-black-3 font-semibold justify-center w-full bg-[#F7F8FA] h-[36px]'}>Legend</header>
            <div className={'flex w-full gap-x-3 px-3 py-3 items-center cursor-pointer'}>
              <label className={'text-base text-f-black-2 w-[100px]'}>Display</label>
              <div className={'flex px-1 py-1 rounded  w-full bg-[#F7F8FA]'}>
                <div
                  onClick={() => this.setDisplay(true)}
                  className={`flex ${legend.display ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/2 px-1 py-1 text-sm cursor-pointer`}
                >
                  Show
                </div>
                <div
                  onClick={() => this.setDisplay(false)}
                  className={`flex ${!legend.display ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/2 px-1 py-1 text-sm cursor-pointer`}
                >
                  Hide
                </div>
              </div>
            </div>

            <div className={'flex w-full gap-x-3 px-3 py-3 items-center cursor-pointer'}>
              <label className={'text-base text-f-black-2 w-[100px]'}>Position</label>
              <div className={'flex px-1 py-1 rounded gap-x-1 w-full bg-[#F7F8FA]'}>
                <div
                  onClick={() => this.setPosition('left')}
                  className={`flex ${legend.position == 'left' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  <Icon icon={'window-left'} size={16} />
                </div>
                <div
                  onClick={() => this.setPosition('right')}
                  className={`flex ${legend.position == 'right' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  <Icon icon={'window-right'} size={16} />
                </div>
                <div
                  onClick={() => this.setPosition('top')}
                  className={`flex ${legend.position == 'top' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  <Icon icon={'window-up'} size={16} />
                </div>
                <div
                  onClick={() => this.setPosition('bottom')}
                  className={`flex ${legend.position == 'bottom' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  <Icon icon={'window-bottom'} size={16} />
                </div>
              </div>
            </div>

            <div className={'flex w-full gap-x-3 px-3 py-3 items-center cursor-pointer'}>
              <label className={'text-base text-f-black-2 w-[100px]'}>Alignment</label>
              <div className={'flex px-1 py-1 rounded  w-full bg-[#F7F8FA]'}>
                <div
                  onClick={() => this.setAlignment('start')}
                  className={`flex ${legend.align == 'start' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  Start
                </div>
                <div
                  onClick={() => this.setAlignment('center')}
                  className={`flex ${legend.align == 'center' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  Center
                </div>
                <div
                  onClick={() => this.setAlignment('end')}
                  className={`flex ${legend.align == 'end' ? 'bg-white opacity-100 font-semibold shadow-sm shadow-black/2 rounded-sm ' : 'opacity-50'} items-center justify-center w-1/3 px-1 py-1 text-sm cursor-pointer`}
                >
                  End
                </div>
              </div>
            </div>
          </div>
        </OverlayPanel>
      </button>
    );
  }

  private setAlignment = (align: Align) => {
    const {
      chart: { chart },
      changeChart,
    } = this.props;
    const legend: LegendOptions<any> | undefined = chart.visualOptions?.plugins?.legend as any;
    if (!legend) return;
    legend.align = align;
    changeChart(chart);
  };

  private openOverlayPanel = (e: any) => {
    this.overlayPanelRef?.toggle(e);
  };

  private setDisplay = (display: boolean) => {
    const {
      chart: { chart },
      changeChart,
    } = this.props;
    const legend: LegendOptions<any> | undefined = chart.visualOptions?.plugins?.legend as any;
    if (!legend) return;
    legend.display = display;
    changeChart(chart);
  };

  private setPosition = (position: 'left' | 'right' | 'top' | 'bottom') => {
    const {
      chart: { chart },
      changeChart,
    } = this.props;
    const legend: LegendOptions<any> | undefined = chart.visualOptions?.plugins?.legend as any;
    if (!legend) return;
    legend.position = position;
    changeChart(chart);
  };
}

class State {}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});

const mapDispatchToProps = { changeChart };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(LegendOptionPanel);
